import { ComponentFactoryResolver, Pipe, PipeTransform } from '@angular/core';
import { SPRACompetitionCsaRate } from '../Models/ops';

@Pipe({ name: 'getCompCsaRateGreaterThenZero' })
export class GetCompCsaRateGreaterThenZero implements PipeTransform {
  transform(itemList?:Array<SPRACompetitionCsaRate>) {
      if(itemList != undefined){
        return itemList.filter((i) =>{return  (i.Rate != undefined && i.Rate>0)});
      }else{
        return undefined;
      }
    
  }
}